import type { FlightInformation, FlightLeg, FlightLuggageItem } from '../../domain/types'
import type { FlightInformationAPIResponse, FlightInformationLegAPIResponse, FlightLuggageItemAPIResponse } from '../types'

function mapFlightLuggageItem(item: FlightLuggageItemAPIResponse): FlightLuggageItem {
  return {
    type: item.type ?? '',
    size: item.size ?? '',
    description: item.description ?? '',
    weightInKg: item.weightInKg ?? '',
    participantIds: item.participantIds ?? [],
  }
}

function mapFlightLeg(leg: FlightInformationLegAPIResponse): FlightLeg {
  return {
    airlineCode: leg.airlineCode ?? '',
    airlineName: leg.airlineName ?? '',
    airlineCheckInURL: leg.airlineCheckInURL ?? '',
    airlineSeatReservationURL: leg.airlineSeatReservationURL ?? '',
    flightNumber: leg.flightNumber ?? '',
    remarks: leg.remarks ?? '',
    passengerNameRecord: leg.passengerNameRecord ?? '',
    departureAirportName: leg.departureAirportName ?? '',
    departureAirportCode: leg.departureAirportCode ?? '',
    departureDateTime: leg.departureDateTime ?? '',
    arrivalAirportName: leg.arrivalAirportName ?? '',
    arrivalAirportCode: leg.arrivalAirportCode ?? '',
    arrivalDateTime: leg.arrivalDateTime ?? '',
    showDepartureAndArrivalTimes: leg.showDepartureAndArrivalTimes ?? true,
    isFlexibleFlight: leg.isFlexibleFlight ?? false,
    luggage: (leg.luggage ?? []).map(mapFlightLuggageItem),
  }
}

function mapFlightInformation(apiResponse: FlightInformationAPIResponse): FlightInformation {
  return {
    inbound: apiResponse.inbound ? apiResponse.inbound.map(mapFlightLeg) : null,
    outbound: apiResponse.outbound ? apiResponse.outbound.map(mapFlightLeg) : null,
    participantIds: apiResponse.participantIds ?? [],
  }
}

export function flightInformationMapper(
  apiResponse: FlightInformationAPIResponse[] | null | undefined,
): FlightInformation[] | null {
  if (!apiResponse?.length)
    return null

  return apiResponse.map(mapFlightInformation)
}
